
export enum OrderByUser {
	NameAscending = 1,
	NameDescending = 2,
	UsernameAscending = 3,
	UsernameDescending = 4,
	CreatedAtAscending = 5,
	CreatedAtDescending = 6,
	JobRoleAscending = 7,
	JobRoleDescending = 8
}
